/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, type RedirectProps } from 'react-router-dom';
import { getUserRoleSelector } from '../../state-manager/selectors/appSelectors';

// Defense-in-depth guard for clinician/admin-only routes. The role-driven
// redirect in App() already sends patients to /patient on login, but this
// blocks a patient who deep-links straight to a clinician route. Does not
// redirect while role is still undefined (initial load) — only patients.
export default function RequireNonPatient({
  children,
  to = '/patient',
}: {
  children: ReactNode;
  to?: RedirectProps['to'];
}) {
  const role = useSelector(getUserRoleSelector);
  if (role === 'patient') {
    return <Redirect to={to} />;
  }
  return <>{children}</>;
}
